import isValidAnswer from '@opsbase/lib-form/helpers/isValidAnswer';
import { flagColor } from '@opsbase/lib-issue/Flag';
import Horizontal from '@opsbase/web-layout/Horizontal/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import React, { useContext } from 'react';
import DetailsReportSwab from '../DetailsReportSwab';
import DetailsOpReportAnswerCell from './DetailsOpReportAnswerCell';
import { DetailsOpReportQuestionContext } from './DetailsOpReportQuestion';
export function DetailsOpReportAnswerList() {
    const { r, a, q } = useContext(DetailsOpReportQuestionContext);
    const right = false;
    // If answered
    if (isValidAnswer(a, q, r)) {
        const value = a.value;
        const c = r;
        const allValues = value.split(',');
        allValues.sort((va, vb) => {
            const aIdx = c.options.findIndex(o => o.value === va);
            const bIdx = c.options.findIndex(o => o.value === vb);
            return aIdx - bIdx;
        });
        const text = allValues
            .filter(v => !!v)
            .map((v, idx) => {
            var _a, _b;
            return (React.createElement(Horizontal, { key: `answer${idx}`, gutter: true, justify: 'flex-start' },
                React.createElement(DetailsReportSwab, { color: flagColor((_a = c.options.find(o => o.value.toString() === v)) === null || _a === void 0 ? void 0 : _a.flag) }),
                ((_b = c.options.find(o => o.value.toString() === v)) === null || _b === void 0 ? void 0 : _b.label) || '? ? ?'));
        });
        return (React.createElement(DetailsOpReportAnswerCell, { right: right },
            React.createElement(Vertical, { gutter: true }, text)));
    }
    // Otherwise
    else {
        return React.createElement(DetailsOpReportAnswerCell, { right: right }, "- - -");
    }
}
export default DetailsOpReportAnswerList;
